import i18n from '@/lib/i18n';

const ENTITY_MAP: Record<string, string> = {
  user: 'Người dùng',
  company: 'Công ty',
  department: 'Phòng ban',
  role: 'Quyền',
  permission: 'Phân quyền',
};

const FIELD_MAP: Record<string, string> = {
  login: 'tài khoản',
  email: 'email',
  code: 'mã',
  name: 'tên',
};

const ERROR_PATTERNS = [
  {
    regex: /^(\w+) with (\w+) '([^']+)' already exists\.?$/i,
    translate: (matches: RegExpMatchArray) => {
      const entity = matches[1].toLowerCase();
      const field = matches[2].toLowerCase();
      const value = matches[3];

      if (i18n.language === 'vi') {
        const entityVi = ENTITY_MAP[entity] || entity;
        const fieldVi = FIELD_MAP[field] || field;
        return `${entityVi} với ${fieldVi} '${value}' đã tồn tại`;
      }
      return null;
    },
  },
  {
    regex: /^(\w+) '([^']+)' already exists\.?$/i,
    translate: (matches: RegExpMatchArray) => {
      const field = matches[1].toLowerCase();
      const value = matches[2];

      if (i18n.language === 'vi') {
        const fieldVi = FIELD_MAP[field] || field;
        return `${fieldVi.charAt(0).toUpperCase() + fieldVi.slice(1)} '${value}' đã tồn tại`;
      }
      return null;
    },
  },
  {
    regex: /^(\w+) not found\.?$/i,
    translate: (matches: RegExpMatchArray) => {
      const entity = matches[1].toLowerCase();

      if (i18n.language === 'vi') {
        const entityVi = ENTITY_MAP[entity] || entity;
        return `Không tìm thấy ${entityVi}`;
      }
      return null;
    },
  },
  {
    regex: /^Cannot delete .+ because .+$/i,
    translate: () => {
      if (i18n.language === 'vi') {
        return 'Không thể xóa do có dữ liệu liên quan';
      }
      return null;
    },
  },
  {
    regex: /^(Access denied|Unauthorized)\.?$/i,
    translate: () => {
      if (i18n.language === 'vi') {
        return 'Bạn không có quyền thực hiện thao tác này';
      }
      return null;
    },
  },
  {
    regex: /^Invalid (\w+)\.?$/i,
    translate: (matches: RegExpMatchArray) => {
      const field = matches[1].toLowerCase();

      if (i18n.language === 'vi') {
        const fieldVi = FIELD_MAP[field] || field;
        return `${fieldVi.charAt(0).toUpperCase() + fieldVi.slice(1)} không hợp lệ`;
      }
      return null;
    },
  },
];

export function translateApiError(message: string): string {
  if (!message) return i18n.t('common.apiErrors.unknown');

  for (const pattern of ERROR_PATTERNS) {
    const matches = message.match(pattern.regex);
    if (matches) {
      const translated = pattern.translate(matches);
      if (translated) return translated;
    }
  }

  return message;
}
